import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function sendContractReminder(id: number) {
  return restApiClient
    .url(constructApiUrl(API.affectedStaffs.sendContractReminder.url, { id }))
    .post()
}
